module.exports = __webpack_public_path__ + "static/img/y8.f1a7277.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y8.jpg
// module id = 9Gld
// module chunks = 1